import React, { PureComponent } from 'react';
import { Box, ClipboardInput } from '..'; 
import { ImageresizeApi } from 'modules';
import {
  FacebookShareButton,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon
} from 'react-share';

import styles from './styles';

export default class ScrollWindow extends PureComponent {

  render() {
    const shareUrl = ImageresizeApi.BASE_URL + location.pathname;
    let shareLink;
    switch (location.pathname) {
      case "/bulk-resize":
        shareLink = '<a href="https://imageresize.org/bulk-resize" target="_blank">Bulk Image Resizer</a>';
        break;
      case '/compress-images':
        shareLink = '<a href="https://imageresize.org/compress-images" target="_blank">Compress Images</a>';
        break;
      case "/pdf-resize":
        shareLink = '<a href="https://imageresize.org/pdf-resize" target="_blank">Bulk PDF Resizer</a>';
        break;
      case "/pdf-compressor":
        shareLink = '<a href="https://imageresize.org/pdf-compression" target="_blank">PDF compressor</a>';
        break;
      default:
        shareLink = '<a href="https://imageresize.org" target="_blank">Image Resizer</a>';
        break;
    }
    return (  
      <Box className={styles.shareBox}>
        <p className={styles.title}>Has ImageResize helped you? you can help us too! </p>
        <FacebookShareButton url={shareUrl} >
          <FacebookIcon size={32} round={true} />
        </FacebookShareButton>
        <TwitterShareButton url={shareUrl} >
          <TwitterIcon size={32} round={true} />
        </TwitterShareButton>
        <ClipboardInput
          label="Or link to us"
          value={shareLink}
        />
      </Box>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/ShareBox/index.jsx